import {matchPath, NavLink, useLocation} from 'react-router-dom';

import {cn} from '@common/css/helpers';

const links = [
  {to: '/products', label: 'Products', matchPaths: ['/products', '/product-sheet']},
  {to: '/compositions', label: 'Compositions', matchPaths: ['/compositions', '/composition-sheet']},
  {to: '/referentials', label: 'Referentials', matchPaths: ['/referentials']},
  {to: '/skus', label: 'SKUs', matchPaths: ['/skus']}
];

const HeaderMenu = () => {
  const location = useLocation();

  return links.map(({to, label, matchPaths}) => {
    const isActive = matchPaths.some(path => matchPath({path, end: false}, location.pathname));

    return (
      <NavLink key={to} to={to} className={cn('cursor-pointer px-6 py-3 border-b-4', isActive ? 'border-red text-red' : 'border-transparent text-gray-link')}>
        {label}
      </NavLink>
    );
  });
};

export default HeaderMenu;
